import {DosyaBorclu} from "../uyap/DosyaBorclu";
import {IKurumDVO} from "../uyap/CommonInterfaces";
import {SnapshotOkuyucu} from "./SnapshotOkuyucu";
import {dosyaRefCoz} from "./DosyaRefHafizasi";

/**
 * kod inceleme (T2-37/T2-38): B32-2 dosya-önyükleme bloğu TakipSorgulaTaskHandler
 * ve TopluHacizHazirlaTaskHandler'da birebir kopyaydı; buraya çıkarıldı.
 *
 * B32-2 (DEV-2603): borçlu döngüsünün İÇİNDE borçlu başına AYRI bir toplu-GET
 * yerine, döngü BAŞLAMADAN ÖNCE TÜM borçluların TÜM alanlarını TEK POST
 * (`/api/v1/sorgu-snapshot/toplu-oku`) ile SnapshotOkuyucu memo'suna taşır —
 * dosya başına 1 istek hedefi (bkz. icrapro-app/docs/sorgu-snapshot-sistemi.md §2.2). Sonrasındaki borçlu/alan
 * döngüsü (UyapRequest.isDataCached/run üzerinden) kendi ALAN BAZLI GET'ini
 * atmak yerine bu memo isabetini bulur. dosyaRef yoksa, POST başarısız olursa
 * ya da bir borçlu/alan bulk cevapta yoksa sessizce atlanır — davranış
 * bugünküyle AYNI kalır (SnapshotOkuyucu.dosyayiOnYukle KENDİ try/catch'i
 * içinde ASLA throw etmez). UYAP'a giden sorguların SIRASI/SAYISI DEĞİŞMEZ.
 */
export async function gorevIcinDosyayiOnYukle(dosyaId: any, borclular: Array<DosyaBorclu>): Promise<void> {
    const dosyaRef = dosyaRefCoz(dosyaId);
    if (dosyaRef) {
        await SnapshotOkuyucu.dosyayiOnYukle(
            dosyaRef,
            borclular.map((borclu) => ({
                kisiKurumId: borclu.kisiKurumId,
                vergiNo: borclu.isKurum() ? (borclu.borcluBilgileri as IKurumDVO).vergiNo : null
            }))
        );
    }
}
